module.exports = __webpack_public_path__ + "img/i-options-admin.4fc0b725.svg";